export const DEFAULT_COLORS = {
  dark: '#0e0e0e',
  light: '#ffffff',
};
